// @mui
import { GlobalStyles as MUIGlobalStyles } from '@mui/material'
import Background from '../resources/images/background.png'

// ----------------------------------------------------------------------

export default function GlobalStyles() {
  const inputGlobalStyles = (
    <MUIGlobalStyles
      styles={{
        '*': {
          scrollbarWidth: 'none', // Firefox
          '-ms-overflow-style': 'none', // Edge
          // WebKit-based browsers (Chrome, Safari, Edge)
          '&::-webkit-scrollbar': {
            display: 'none',
          },
        },
        html: {
          margin: 0,
          padding: 0,
          width: '100%',
          minHeight: '100%',
          WebkitOverflowScrolling: 'touch',
        },
        body: {
          margin: 0,
          padding: 0,
          width: '100%',
          minHeight: '100%',
          display: 'flex',
          flexDirection: 'column',
          backgroundImage: `url(${Background})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        },
        '#root': {
          width: '100%',
          minHeight: '100%',
        },
        input: {
          '&[type=number]': {
            MozAppearance: 'textfield',
            '&::-webkit-outer-spin-button': {
              margin: 0,
              WebkitAppearance: 'none',
            },
            '&::-webkit-inner-spin-button': {
              margin: 0,
              WebkitAppearance: 'none',
            },
          },
        },
        img: {
          display: 'block',
          maxWidth: '100%',
        },
        ul: {
          margin: 0,
          padding: 0,
        },
        a: {
          textDecoration: 'none',
        },
      }}
    />
  )

  return inputGlobalStyles
}
